<template>
  <div class="w-full">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PayrollIndex'
};
</script>
